<kiwi-decision-content *ngIf="decision" class="financialContent cell-block-y">
    <table class="_tableColor">
        <tbody>
        <tr class="_titlePartTable">
            <td [i18nKey]="'decisions.financial.insurances.contract.type'"></td>
            <td [i18nKey]="'decisions.financial.insurances.subscription'"></td>
            <td class="_number"[i18nKey]="'decisions.financial.insurances.monthly.cost'"></td>
        </tr>
        <tr>
            <td [i18nKey]="'decisions.financial.insurances.liability'"></td>
            <td class="_checkboxLine">
                <checkbox
                    [disabled]="decisionsReadonly"
                    [checked]="decision.liabilityInsuranceTakenOut"
                    (valueChanged)="onLiabilityInsuranceTakenOutChange($event)">
                </checkbox>
            </td>
            <td class="_number">
                {{parameters.liabilityInsuranceCost | number:'1.2'}}
            </td>
        </tr>

        <tr>
            <td [i18nKey]="'decisions.financial.insurances.operating.loss'"></td>
            <td class="_checkboxLine">
                <checkbox
                    [disabled]="decisionsReadonly"
                    [checked]="decision.operatingLossInsuranceTakenOut"
                    (valueChanged)="onOperatingLossInsuranceTakenOutChange($event)">
                </checkbox>
            </td>
            <td class="_number">
                {{parameters.operatingLossInsuranceCost | number:'1.2'}}
            </td>
        </tr>

        <tr>
            <td [i18nKey]="'decisions.financial.insurances.property'"></td>
            <td class="_checkboxLine">
                <checkbox
                    [disabled]="decisionsReadonly"
                    [checked]="decision.propertyInsuranceTakenOut"
                    (valueChanged)="onPropertyInsuranceTakenOutChange($event)">
                </checkbox>
            </td>
            <td class="_number">
                {{parameters.propertyInsuranceCost | number:'1.2'}}
            </td>
        </tr>

        <tr>
            <td [i18nKey]="'decisions.financial.insurances.discount'"></td>
            <td>
            </td>
            <td class="_number">
                {{((decision.propertyInsuranceTakenOut && decision.operatingLossInsuranceTakenOut &&
                decision.liabilityInsuranceTakenOut) ? parameters.discount : 0) | number:'1.2'}}
            </td>
        </tr>

        <tr>
            <td class="_totalColumn"[i18nKey]="'common.total'"></td>
            <td></td>
            <td class="_totalColumn _number">{{totalInsurancesCost | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>
</kiwi-decision-content>
